// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Input UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  --ezInputFontFamily: 'Font-Family-ezClocker', 'Roboto', 'Noto Sans', 'Verdana', 'Arial', sans-serif;
  --ezInputMonospaceFontFamily: monospace;
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Input Styles
| Tags: <input/>
|-------------------------------------------------------------------
| Available Styles:
|   input <default>
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
input {
  font-family: var(--ezInputFontFamily);
  font-size: 12pt;
  padding: 4px;
  box-sizing: border-box;
  /* Opera/IE 8+ */
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 0;
  border-radius: 3px;
}

input:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

input:invalid {
  background-color: #ffeeee;
  border-color: #FF0700;
  border-width: 1px;
  box-shadow: none;
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Select Input Styles
| Tags: <select/>
|-------------------------------------------------------------------
| Available Styles:
|   ezSelectMenu
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
select {
  margin: 4px 4px 4px 0;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

select:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

select.reportsOverride,
select.ez-reports-override {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

select.reportsOverride:focus,
select.ez-reports-override:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

select.ezSelect {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

select.ezSelect:enabled:hover {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
}

select.ezSelect:enabled:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

select.ezSelectHeader {
  font-size: 12pt;
  font-weight: bold;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

select.ezSelectHeader:hover {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
}

select.ezSelectHeader:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Select Option Styles
| Tags: <option/>
|-------------------------------------------------------------------
| Available Styles:
|   option <tag default>
|   ezOption
|   ezOptionHeader
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
option {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

option:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

option.ezOption {
  font-size: 12pt;
  padding: 4px;
}

option.ezOptionHeader {
  font-size: 14pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

option.ezOptionHeader:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

/* Firefox mis-hit-tests native <select> popup rows when <option> elements carry margin/border/
   padding (from the global "option" rule above), causing clicks on the first employee to
   register on the "[ Select Employee ]" placeholder above it instead (EW-2040). */
#employeeCombo option {
  margin: 0;
  border: none;
  padding: 0;
  font-size: inherit;
}

#employeeCombo option:focus {
  border: none;
  outline: none;
  box-shadow: none;
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| JQuery Select Input Styles
| Tags: <select/>
|-------------------------------------------------------------------
| Available Styles:
|   ezSelectMenu
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
/* for jQuery's SelectMenu component */
.ezSelectMenu {
  width: auto;
  padding: 4px;
  margin: 4px 4px 4px 0;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

.ezSelectMenu:hover {
  color: var(--ezClockerBlack);
  font-weight: bold;
  background-color: #ffdb64;
}

.ezSelectMenu:active {
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-color: #ffcc66;
}

.ezSelectMenu:disabled {
  font-weight: normal;
  background-color: #ffdb64;
  color: #c69800;
  border-color: #c69800;
}

.ezSelectMenu:focus {
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

input[type=date].ezDate {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=date].ezDate:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=datetime].ezDateTime {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=datetime].ezDateTime:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=datetime-local].ezDateTimeLocal {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=datetime-local].ezDateTimeLocal:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=email].ezEmail {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=email].ezEmail:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=file].ezFile {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
}

input[type=image].ezImage {
  border-style: solid;
  border-color: var(--ezClockerGray);
  border-width: 1px;
}

input[type=image].ezImage:hover {
  border-style: solid;
  border-color: var(--ezClockerBlack);
  border-width: 1px;
}

input[type=month].ezMonth {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=month].ezMonth:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=number].ezNumber {
  font-size: 12pt;
  font-family: var(--ezInputFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=number].ezNumber:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=number].ezNumber:disabled {
  color: #e0e0e0;
  border-color: #e0e0e0;
  outline-color: #e0e0e0;
  outline-style: solid;
  outline-width: 1px;
}

input[type=password].ezPassword {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=password].ezPassword:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=radio].ezRadio {
  background-color: transparent;
}

input[type=reset].ezResetMajor {
  display: inline-block;
  padding: 6px 24px;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezClockerBlack);
  cursor: pointer;
}

input[type=reset].ezResetMajor:hover {
  background-color: #ffcc66;
}

input[type=reset].ezResetMajor:active {
  background-color: #ff9933;
}

input[type=reset].ezResetActionButton {
  display: inline-block;
  padding: 6px 24px;
  background-color: #8df13c;
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezActionGreenBorderColor);
  cursor: pointer;
}

input[type=reset].ezResetActionButton:hover {
  background-color: var(--ezActionGreenHoverColor);
}

input[type=reset].ezResetActionButton:active {
  color: var(--ezActionGreenHoverColor);
  background-color: var(--ezActionGreenBorderColor);
}

input[type=reset].ezResetEdit {
  display: inline-block;
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: normal;
  border-radius: 3px;
  border: 1px solid var(--ezClockerBlack);
  text-decoration: none;
  cursor: pointer;
}

input[type=reset].ezResetEdit:hover {
  background-color: #edf6ff;
}

input[type=reset].ezResetEdit:active {
  background-color: var(--ezClockerGray);
}

input[type=search].ezSearch {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
}

input[type=submit].ezMajorSubmit {
  display: inline-block;
  padding: 6px 24px;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezClockerBlack);
  cursor: pointer;
}

input[type=submit].ezMajorSubmit:hover {
  background-color: #ffcc66;
}

input[type=submit].ezMajorSubmit:active {
  background-color: #ff9933;
}

input[type=submit].ezSubmitActionButton {
  display: inline-block;
  padding: 6px 24px;
  background-color: #8df13c;
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezActionGreenBorderColor);
  cursor: pointer;
}

input[type=submit].ezSubmitActionButton:hover {
  background-color: var(--ezActionGreenHoverColor);
}

input[type=submit].ezSubmitActionButton:active {
  color: var(--ezActionGreenHoverColor);
  background-color: var(--ezActionGreenBorderColor);
}

input[type=submit].ezSubmitEdit {
  display: inline-block;
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: normal;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezClockerBlack);
  cursor: pointer;
}

input[type=submit].ezSubmitEdit:hover {
  background-color: #edf6ff;
}

input[type=submit].ezSubmitEdit:active {
  background-color: var(--ezClockerGray);
}

input[type=tel].ezTel {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=tel].ezTel:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=text].ezText {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=text].ezText:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=time].ezTime {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=time].ezTime:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=url].ezUrl {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=url].ezUrl:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=week].ezWeek {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=week].ezWeek:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

textarea {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  font-size: 12pt;
  font-family: "Roboto", Verdana, sans-serif;
  /* font-family: var(--ezInputMonospaceFontFamily); */
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

textarea:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  border-radius: 3px;
}

textarea.mono-spaced {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ez-error-message-textarea-container {
  margin: 8px;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  align-content: start;
  align-content: stretch;
}

textarea.ez-error-message-details {
  width: 90%;
  font-family: var(--ezInputMonospaceFontFamily);
  color: var(--ezClockerGray);
  font-size: 10pt;
  border-radius: 3px;
}

textarea.ezTextArea-noresize-w100 {
  resize: none;
  width: 99%;
}

textarea.ezTextArea-medium-100 {
  width: 99%;
}

.ezInputs-large-fake-editor {
  margin: 0;
  min-height: 24px;
  padding: 4px;
  box-sizing: border-box;
  background-color: var(--ezClockerWhite);
  font-family: Roboto, Verdana, sans-serif;
  font-size: 18pt;
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
}

.ezInputs-large-fake-editor-no-border {
  margin: 0;
  min-height: 24px;
  padding: 4px;
  box-sizing: border-box;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerNavy);
  font-family: var(--ezInputFontFamily);
  font-size: 14pt;
  border-style: none;
}

.ezMajorInputLabel {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezFontColor);
  font-weight: bold;
  font-size: 16pt;
}

.ezInput-label-white-12pt-bold {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezClockerWhite);
  font-size: 12pt;
  font-weight: bold;
}

.ezInput-label-black-12pt-bold {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
}

.ezInput-label-black-14pt,
.ezInputLabel,
.ezEditorLabel,
.editorLabel {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezFontColor);
  font-size: 14pt;
}

.ezInput-label-black-14pt-bold,
.ezBoldInputLabel {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezFontColor);
  font-size: 14pt;
}

.ezInputs-checkbox-radio-label {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezFontColor);
  font-size: 14pt;
  line-height: 18px;
  cursor: pointer;
}

.ezTogglesLabel {
  color: var(--ezFontColor);
  font-size: 14pt;
  text-align: left;
  vertical-align: middle;
}

.ezInputFormatLabel {
  color: var(--ezClockerGray);
  font-size: 10pt;
}

.ezLargeInputEditor {
  font-size: 18pt;
}

.ezInputs-authentication-full-width {
  box-sizing: border-box;
  width: 100%;
  font-size: 18pt;
}

.ezInputs-large-full-width {
  box-sizing: border-box;
  width: 100%;
  font-size: 12pt;
}

.ezOversizedEditor,
.oversizedEditor {
  font-size: 16pt;
  font-style: bold;
}

.ezDialogEditor {
  font-size: 12pt;
  box-sizing: border-box;
  width: 100%;
}

.ezFullWidthEditor,
.fullWidthEditor {
  width: 100%;
  box-sizing: border-box;
}

.ezInputLabelGroupContainer {
  padding: 0;
  margin-top: 4px;
  margin-bottom: 4px;
}

.ezInputLabelGroupContainerDisplayFlex {
  display: flex;
  align-items: center;
}

.ezInputLabelGroupContainerFixedWidth {
  flex: 0 0 200px;
}

.ezInputErrorHighlight {
  background-color: var(--ezClockerInputErrorBackground);
  border-color: var(--ezBorderAlertRed);
  border-width: 2px;
  border-style: solid;
}

.ezInputWarningHighlight {
  background-color: var(--ezClockerInputWarningBackground);
  border-color: var(--ezBorderWarningYellow);
  border-width: 2px;
  border-style: solid;
}

.ezDisabledICheck {
  background-color: #e0e0e0;
  border-color: #6d6e70;
  opacity: 0.5;
  cursor: default;
}

.ezInputs-disabled-icheck {
  opacity: 0.5;
  cursor: default;
}

.ezInputs-important-data {
  font-size: 12pt;
}

.ezDisabledLabel {
  color: #e0e0e0;
}

.ezText-input-label-disabled {
  color: #e0e0e0;
  cursor: default;
}

.ez-input-validation-error {
  background-color: var(--ezClockerInputErrorBackground);
  border-color: var(--ezBorderAlertRed);
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  .ezInputs-large-fake-editor {
    display: grid;
    box-sizing: border-box;
    min-height: 30px;
    margin: 0;
    padding: 4px;
    justify-content: left;
    align-content: center;
    background-color: var(--ezClockerWhite);
    font-family: Roboto, Verdana, sans-serif;
    font-size: 12pt;
    border-color: var(--ezClockerSilver);
    border-style: solid;
    border-width: 1px;
    vertical-align: middle;
  }
  .ezInputs-large-full-width {
    box-sizing: border-box;
    width: 100%;
    font-size: 12pt;
  }
}
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  .ezInputs-large-fake-editor {
    display: grid;
    box-sizing: border-box;
    min-height: 30px;
    margin: 0;
    padding: 4px;
    justify-content: left;
    align-content: center;
    background-color: var(--ezClockerWhite);
    font-family: Roboto, Verdana, sans-serif;
    font-size: 12pt;
    border-color: var(--ezClockerSilver);
    border-style: solid;
    border-width: 1px;
    vertical-align: middle;
  }
  .ezInputs-large-full-width {
    box-sizing: border-box;
    width: 100%;
    font-size: 12pt;
  }
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-inputs.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,mGAAA;EACA,uCAAA;AAAJ;;AAGA;;;;;;mEAAA;AAOA;EACI,qCAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAGA;;;;;;mEAAA;AAOA;EACI,qBAAA;EACA,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;;EAEI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;;EAEI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,eAAA;EACA,iBAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;;;;;;;;mEAAA;AASA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;;kFAAA;AAGA;EACI,SAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;AAAJ;;AAGA;;;;;;mEAAA;AAQA,sCAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAKA;EACI,4BAAA;EACA,iBAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,4BAAA;EACA,iBAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,4BAAA;EACA,iBAAA;EACA,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EAEA,uDAAA;EACA,0CAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,kCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,mCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,qCAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,6BAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,iBAAA;EACA,wCAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gDAAA;AAHJ;;AAMA;EACI,qCAAA;EACA,iDAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,uCAAA;EACA,qBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,sCAAA;AAHJ;;AAMA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,iBAAA;EACA,wCAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gDAAA;AAHJ;;AAMA;EACI,qCAAA;EACA,iDAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,sCAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,uCAAA;EACA,eAAA;EACA,8CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,uCAAA;EACA,eAAA;EACA,0CAAA;EACA,oDAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,uCAAA;EACA,eAAA;EACA,8CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,aAAA;EACA,2BAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;AAHJ;;AAMA;EACI,UAAA;EACA,8CAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,UAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;;AAMA;EACI,SAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,wCAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,SAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;AAHJ;;AAMA;;;;EAII,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAHJ;;AAMA;;EAEI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAHJ;;AAMA;EACI,2BAAA;EACA,eAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,WAAA;EACA,eAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,WAAA;EACA,eAAA;AAHJ;;AAMA;;EAEI,eAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,sBAAA;EACA,WAAA;AAHJ;;AAMA;;EAEI,WAAA;EACA,sBAAA;AAHJ;;AAMA;EACI,UAAA;EACA,eAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACI,sDAAA;EACA,qCAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,wDAAA;EACA,0CAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAHJ;;AAMA;EACI,YAAA;EACA,eAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,cAAA;EACA,eAAA;AAHJ;;AAMA;EACI,sDAAA;EACA,qCAAA;AAHJ;;AAOA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAMA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,YAAA;IACA,qBAAA;IACA,qBAAA;IACA,uCAAA;IACA,wCAAA;IACA,eAAA;IACA,oCAAA;IACA,mBAAA;IACA,iBAAA;IACA,sBAAA;EAPN;EAUE;IACI,sBAAA;IACA,WAAA;IACA,eAAA;EARN;AACF;AAYA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,YAAA;IACA,qBAAA;IACA,qBAAA;IACA,uCAAA;IACA,wCAAA;IACA,eAAA;IACA,oCAAA;IACA,mBAAA;IACA,iBAAA;IACA,sBAAA;EAVN;EAaE;IACI,sBAAA;IACA,WAAA;IACA,eAAA;EAXN;AACF","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Input UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n:root {\n    --ezInputFontFamily: 'Font-Family-ezClocker', 'Roboto', 'Noto Sans', 'Verdana', 'Arial', sans-serif;\n    --ezInputMonospaceFontFamily: monospace;\n}\n\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Input Styles\n| Tags: <input/>\n|-------------------------------------------------------------------\n| Available Styles:\n|   input <default>\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\ninput {\n    font-family: var(--ezInputFontFamily);\n    font-size: 12pt;\n    padding: 4px;\n    box-sizing: border-box;\n    /* Opera/IE 8+ */\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    margin: 0;\n    border-radius: 3px;\n}\n\ninput:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\n}\n\ninput:invalid {\n    background-color: #ffeeee;\n    border-color: #FF0700;\n    border-width: 1px;\n    box-shadow: none;\n}\n\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Select Input Styles\n| Tags: <select/>\n|-------------------------------------------------------------------\n| Available Styles:\n|   ezSelectMenu\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\nselect {\n    margin: 4px 4px 4px 0;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\nselect:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\n}\n\nselect.reportsOverride,\nselect.ez-reports-override {\n    font-size: 12pt;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    margin: 4px 4px 4px 0;\n}\n\nselect.reportsOverride:focus,\nselect.ez-reports-override:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\n}\n\nselect.ezSelect {\n    font-size: 12pt;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    margin: 4px 4px 4px 0;\n}\n\nselect.ezSelect:enabled:hover {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n}\n\nselect.ezSelect:enabled:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\n}\n\nselect.ezSelectHeader {\n    font-size: 12pt;\n    font-weight: bold;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    margin: 4px 4px 4px 0;\n}\n\nselect.ezSelectHeader:hover {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n}\n\nselect.ezSelectHeader:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\n}\n\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Select Option Styles\n| Tags: <option/>\n|-------------------------------------------------------------------\n| Available Styles:\n|   option <tag default>\n|   ezOption\n|   ezOptionHeader\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\noption {\n    font-size: 12pt;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    margin: 4px 4px 4px 0;\n}\n\noption:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\n}\n\noption.ezOption {\n    font-size: 12pt;\n    padding: 4px;\n}\n\noption.ezOptionHeader {\n    font-size: 14pt;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    margin: 4px 4px 4px 0;\n}\n\noption.ezOptionHeader:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\n}\n\n/* Firefox mis-hit-tests native <select> popup rows when <option> elements carry margin/border/\n   padding (from the global \"option\" rule above), causing clicks on the first employee to\n   register on the \"[ Select Employee ]\" placeholder above it instead (EW-2040). */\n#employeeCombo option {\n    margin: 0;\n    border: none;\n    padding: 0;\n    font-size: inherit;\n}\n\n#employeeCombo option:focus {\n    border: none;\n    outline: none;\n    box-shadow: none;\n}\n\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| JQuery Select Input Styles\n| Tags: <select/>\n|-------------------------------------------------------------------\n| Available Styles:\n|   ezSelectMenu\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\n\n/* for jQuery's SelectMenu component */\n.ezSelectMenu {\n    width: auto;\n    padding: 4px;\n    margin: 4px 4px 4px 0;\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n\n}\n\n.ezSelectMenu:hover {\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    background-color: #ffdb64;\n}\n\n.ezSelectMenu:active {\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    border-color: #ffcc66;\n}\n\n.ezSelectMenu:disabled {\n    font-weight: normal;\n    background-color: #ffdb64;\n    color: #c69800;\n    border-color: #c69800;\n}\n\n.ezSelectMenu:focus {\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n\n    /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\n}\n\ninput[type=\"date\"].ezDate {\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"date\"].ezDate:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"datetime\"].ezDateTime {\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"datetime\"].ezDateTime:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"datetime-local\"].ezDateTimeLocal {\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"datetime-local\"].ezDateTimeLocal:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"email\"].ezEmail {\n    font-size: 12pt;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"email\"].ezEmail:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"file\"].ezFile {\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"image\"].ezImage {\n    border-style: solid;\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n}\n\ninput[type=\"image\"].ezImage:hover {\n    border-style: solid;\n    border-color: var(--ezClockerBlack);\n    border-width: 1px;\n}\n\ninput[type=\"month\"].ezMonth {\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"month\"].ezMonth:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"number\"].ezNumber {\n    font-size: 12pt;\n    font-family: var(--ezInputFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"number\"].ezNumber:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"number\"].ezNumber:disabled {\n    color: #e0e0e0;\n    border-color: #e0e0e0;\n    outline-color: #e0e0e0;\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"password\"].ezPassword {\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"password\"].ezPassword:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"radio\"].ezRadio {\n    background-color: transparent;\n}\n\ninput[type=\"reset\"].ezResetMajor {\n    display: inline-block;\n    padding: 6px 24px;\n    background-color: var(--ezClockerOrange);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezInputFontFamily);\n    font-size: 12px;\n    font-weight: bold;\n    text-decoration: none;\n    border-radius: 3px;\n    border: 1px solid var(--ezClockerBlack);\n    cursor: pointer;\n}\n\ninput[type=\"reset\"].ezResetMajor:hover {\n    background-color: #ffcc66;\n}\n\ninput[type=\"reset\"].ezResetMajor:active {\n    background-color: #ff9933;\n}\n\ninput[type=\"reset\"].ezResetActionButton {\n    display: inline-block;\n    padding: 6px 24px;\n    background-color: #8df13c;\n    color: var(--ezClockerBlack);\n    font-family: var(--ezInputFontFamily);\n    font-size: 12px;\n    font-weight: bold;\n    text-decoration: none;\n    border-radius: 3px;\n    border: 1px solid var(--ezActionGreenBorderColor);\n    cursor: pointer;\n}\n\ninput[type=\"reset\"].ezResetActionButton:hover {\n    background-color: var(--ezActionGreenHoverColor);\n}\n\ninput[type=\"reset\"].ezResetActionButton:active {\n    color: var(--ezActionGreenHoverColor);\n    background-color: var(--ezActionGreenBorderColor);\n}\n\ninput[type=\"reset\"].ezResetEdit {\n    display: inline-block;\n    padding: 4px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezInputFontFamily);\n    font-size: 12px;\n    font-weight: normal;\n    border-radius: 3px;\n    border: 1px solid var(--ezClockerBlack);\n    text-decoration: none;\n    cursor: pointer;\n}\n\ninput[type=\"reset\"].ezResetEdit:hover {\n    background-color: #edf6ff;\n}\n\ninput[type=\"reset\"].ezResetEdit:active {\n    background-color: var(--ezClockerGray);\n}\n\ninput[type=\"search\"].ezSearch {\n    font-size: 12pt;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerBlack);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"submit\"].ezMajorSubmit {\n    display: inline-block;\n    padding: 6px 24px;\n    background-color: var(--ezClockerOrange);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezInputFontFamily);\n    font-size: 12px;\n    font-weight: bold;\n    text-decoration: none;\n    border-radius: 3px;\n    border: 1px solid var(--ezClockerBlack);\n    cursor: pointer;\n}\n\ninput[type=\"submit\"].ezMajorSubmit:hover {\n    background-color: #ffcc66;\n}\n\ninput[type=\"submit\"].ezMajorSubmit:active {\n    background-color: #ff9933;\n}\n\ninput[type=\"submit\"].ezSubmitActionButton {\n    display: inline-block;\n    padding: 6px 24px;\n    background-color: #8df13c;\n    color: var(--ezClockerBlack);\n    font-family: var(--ezInputFontFamily);\n    font-size: 12px;\n    font-weight: bold;\n    text-decoration: none;\n    border-radius: 3px;\n    border: 1px solid var(--ezActionGreenBorderColor);\n    cursor: pointer;\n}\n\ninput[type=\"submit\"].ezSubmitActionButton:hover {\n    background-color: var(--ezActionGreenHoverColor);\n}\n\ninput[type=\"submit\"].ezSubmitActionButton:active {\n    color: var(--ezActionGreenHoverColor);\n    background-color: var(--ezActionGreenBorderColor);\n}\n\ninput[type=\"submit\"].ezSubmitEdit {\n    display: inline-block;\n    padding: 4px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezInputFontFamily);\n    font-size: 12px;\n    font-weight: normal;\n    text-decoration: none;\n    border-radius: 3px;\n    border: 1px solid var(--ezClockerBlack);\n    cursor: pointer;\n}\n\ninput[type=\"submit\"].ezSubmitEdit:hover {\n    background-color: #edf6ff;\n}\n\ninput[type=\"submit\"].ezSubmitEdit:active {\n    background-color: var(--ezClockerGray);\n}\n\ninput[type=\"tel\"].ezTel {\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"tel\"].ezTel:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"text\"].ezText {\n    font-size: 12pt;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"text\"].ezText:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"time\"].ezTime {\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"time\"].ezTime:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"url\"].ezUrl {\n    font-size: 12pt;\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"url\"].ezUrl:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ninput[type=\"week\"].ezWeek {\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n}\n\ninput[type=\"week\"].ezWeek:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n}\n\ntextarea {\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    font-size: 12pt;\n    font-family: 'Roboto', Verdana, sans-serif;\n    /* font-family: var(--ezInputMonospaceFontFamily); */\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\ntextarea:focus {\n    border-color: var(--ezClockerOrange);\n    outline-color: var(--ezClockerOrange);\n    outline-style: solid;\n    outline-width: 1px;\n    border-radius: 3px;\n}\n\ntextarea.mono-spaced {\n    padding: 4px;\n    background-color: var(--ezClockerWhite);\n    font-size: 12pt;\n    font-family: var(--ezInputMonospaceFontFamily);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ez-error-message-textarea-container {\n    margin: 8px;\n    display: grid;\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n    align-content: start;\n    align-content:stretch;\n}\n\ntextarea.ez-error-message-details {\n    width: 90%;\n    font-family: var(--ezInputMonospaceFontFamily);\n    color: var(--ezClockerGray);\n    font-size: 10pt;\n    border-radius: 3px;\n}\n\ntextarea.ezTextArea-noresize-w100 {\n    resize: none;\n    width: 99%;\n}\n\ntextarea.ezTextArea-medium-100 {\n    width: 99%;\n}\n\n.ezInputs-large-fake-editor {\n    margin: 0;\n    min-height: 24px;\n    padding: 4px;\n    box-sizing: border-box;\n    background-color: var(--ezClockerWhite);\n    font-family: Roboto, Verdana, sans-serif;\n    font-size: 18pt;\n    border-color: var(--ezClockerSilver);\n    border-style: solid;\n    border-width: 1px;\n}\n\n.ezInputs-large-fake-editor-no-border {\n    margin: 0;\n    min-height: 24px;\n    padding: 4px;\n    box-sizing: border-box;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerNavy);\n    font-family: var(--ezInputFontFamily);\n    font-size: 14pt;\n    border-style: none;\n}\n\n.ezMajorInputLabel {\n    padding-top: 4px;\n    padding-bottom: 2px;\n    color: var(--ezFontColor);\n    font-weight: bold;\n    font-size: 16pt;\n}\n\n.ezInput-label-white-12pt-bold {\n    padding-top: 4px;\n    padding-bottom: 2px;\n    color: var(--ezClockerWhite);\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n.ezInput-label-black-12pt-bold {\n    padding-top: 4px;\n    padding-bottom: 2px;\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n.ezInput-label-black-14pt,\n.ezInputLabel,\n.ezEditorLabel,\n.editorLabel {\n    padding-top: 4px;\n    padding-bottom: 2px;\n    color: var(--ezFontColor);\n    font-size: 14pt;\n}\n\n.ezInput-label-black-14pt-bold,\n.ezBoldInputLabel {\n    padding-top: 4px;\n    padding-bottom: 2px;\n    color: var(--ezFontColor);\n    font-size: 14pt;\n}\n\n.ezInputs-checkbox-radio-label {\n    padding-top: 4px;\n    padding-bottom: 2px;\n    color: var(--ezFontColor);\n    font-size: 14pt;\n    line-height: 18px;\n    cursor: pointer;\n}\n\n.ezTogglesLabel {\n    color: var(--ezFontColor);\n    font-size: 14pt;\n    text-align: left;\n    vertical-align: middle;\n}\n\n.ezInputFormatLabel {\n    color: var(--ezClockerGray);\n    font-size: 10pt;\n}\n\n.ezLargeInputEditor {\n    font-size: 18pt;\n}\n\n.ezInputs-authentication-full-width {\n    box-sizing: border-box;\n    width: 100%;\n    font-size: 18pt;\n}\n\n.ezInputs-large-full-width {\n    box-sizing: border-box;\n    width: 100%;\n    font-size: 12pt;\n}\n\n.ezOversizedEditor,\n.oversizedEditor {\n    font-size: 16pt;\n    font-style: bold;\n}\n\n.ezDialogEditor {\n    font-size: 12pt;\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.ezFullWidthEditor,\n.fullWidthEditor {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.ezInputLabelGroupContainer {\n    padding: 0;\n    margin-top: 4px;\n    margin-bottom: 4px;\n}\n\n.ezInputLabelGroupContainerDisplayFlex {\n    display: flex;\n    align-items: center;\n}\n\n.ezInputLabelGroupContainerFixedWidth {\n    flex: 0 0 200px;\n}\n\n.ezInputErrorHighlight {\n    background-color: var(--ezClockerInputErrorBackground);\n    border-color: var(--ezBorderAlertRed);\n    border-width: 2px;\n    border-style: solid;\n}\n\n.ezInputWarningHighlight {\n    background-color: var(--ezClockerInputWarningBackground);\n    border-color: var(--ezBorderWarningYellow);\n    border-width: 2px;\n    border-style: solid;\n}\n\n.ezDisabledICheck {\n    background-color: #e0e0e0;\n    border-color: #6d6e70;\n    opacity: 0.5;\n    cursor: default;\n}\n\n.ezInputs-disabled-icheck {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.ezInputs-important-data {\n    font-size: 12pt;\n}\n\n.ezDisabledLabel {\n    color: #e0e0e0;\n}\n\n.ezText-input-label-disabled {\n    color: #e0e0e0;\n    cursor: default;\n}\n\n.ez-input-validation-error {\n    background-color: var(--ezClockerInputErrorBackground);\n    border-color: var(--ezBorderAlertRed);\n}\n\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n}\n*/\n\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n@media screen and (max-width: 480px) {\n    .ezInputs-large-fake-editor {\n        display: grid;\n        box-sizing: border-box;\n        min-height: 30px;\n        margin: 0;\n        padding: 4px;\n        justify-content: left;\n        align-content: center;\n        background-color: var(--ezClockerWhite);\n        font-family: Roboto, Verdana, sans-serif;\n        font-size: 12pt;\n        border-color: var(--ezClockerSilver);\n        border-style: solid;\n        border-width: 1px;\n        vertical-align: middle;\n    }\n\n    .ezInputs-large-full-width {\n        box-sizing: border-box;\n        width: 100%;\n        font-size: 12pt;\n    }\n}\n\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n@media screen and (max-width: 319px) {\n    .ezInputs-large-fake-editor {\n        display: grid;\n        box-sizing: border-box;\n        min-height: 30px;\n        margin: 0;\n        padding: 4px;\n        justify-content: left;\n        align-content: center;\n        background-color: var(--ezClockerWhite);\n        font-family: Roboto, Verdana, sans-serif;\n        font-size: 12pt;\n        border-color: var(--ezClockerSilver);\n        border-style: solid;\n        border-width: 1px;\n        vertical-align: middle;\n    }\n\n    .ezInputs-large-full-width {\n        box-sizing: border-box;\n        width: 100%;\n        font-size: 12pt;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
